<template>
	<v-container fluid>
		<v-layout row wrap>
			<v-tabs color="#fafafa" v-model="tabId">
				<v-tab>{{ $t('tabs.opportunityHistory') }}</v-tab>
				<v-tab>{{ $t('tabs.emailHistory') }}</v-tab>
				<v-tab-item>
					<v-flex xs12>
						<v-card class="elevation-0 background-transparent">
							<DataTable
								:excel="false"
								:headers="historyTable.headers"
								:items="historyTable.items"
								:total="historyTable.total"
								@excel="excelExport"
								@reload="reloadData"
							>
								<template #row="props">
									<tr :class="{'cursor-pointer': true}" @contextmenu.prevent="editClick(props.item.id, true)">
										<td @click="editClick(props.item.id, false)">{{ props.item.user_display }}</td>
										<td @click="editClick(props.item.id, false)">{{ props.item.vtiger_id }}</td>
										<td @click="editClick(props.item.id, false)">{{ props.item.time_display }}</td>
										<td @click="editClick(props.item.id, false)">{{ props.item.field }}</td>
										<td @click="editClick(props.item.id, false)">{{ props.item.old_value }}</td>
										<td @click="editClick(props.item.id, false)">{{ props.item.new_value }}</td>
									</tr>
								</template>
							</DataTable>
						</v-card>
					</v-flex>
				</v-tab-item>
				<v-tab-item>
					<v-flex xs12>
						<v-card class="elevation-0 background-transparent">
							<DataTable
								:excel="false"
								:headers="emailTable.headers"
								:items="emailTable.items"
								:total="emailTable.total"
								@excel="excelExportEmails"
								@reload="reloadDataEmails"
							>
								<template #row="props">
									<tr :class="{'cursor-pointer': true}" @contextmenu.prevent="editClick(props.item.id, true)">
										<td @click="editClick(props.item.id, false)">{{ props.item.user }}</td>
										<td @click="editClick(props.item.id, false)">{{ props.item.recipient }}</td>
										<td @click="editClick(props.item.id, false)">{{ props.item.time_display }}</td>
										<td @click="editClick(props.item.id, false)">{{ props.item.subject }}</td>
										<td @click="editClick(props.item.id, false)" v-html="props.item.body" class="py-2"></td>
									</tr>
								</template>
							</DataTable>
						</v-card>
					</v-flex>
				</v-tab-item>
			</v-tabs>
		</v-layout>
	</v-container>
</template>

<script>
import DataTable from "./trinkets/DataTable";

export default {
	name: "History",
	components: {DataTable},
	data: function () {
		return {
			historyTable: {
				headers: [
					{text: this.$t('fields.userId'), value: 'user', type: 'multiple|users', searchable: 'hidden'},
					{text: this.$t('fields.vtigerId'), value: 'opportunity', type: 'string', searchable: 'hidden'},
					{text: this.$t('fields.time'), value: 'time', type: 'date_range', searchable: 'hidden'},
					{text: this.$t('fields.field'), value: 'field', type: 'string', searchable: false},
					{text: this.$t('fields.oldValue'), value: 'oldValue', type: 'string', searchable: false},
					{text: this.$t('fields.newValue'), value: 'newValue', type: 'string', searchable: false}
				],
				items: [],
				total: 0,
				lastRequest: null
			},
			emailTable: {
				headers: [
					{text: this.$t('fields.userId'), value: 'user', type: 'multiple|users', searchable: 'hidden'},
					{text: this.$t('fields.recipient'), value: 'recipient', type: 'string', searchable: 'hidden'},
					{text: this.$t('fields.emailTime'), value: 'time', type: 'date_range', searchable: 'hidden'},
					{text: this.$t('fields.subject'), value: 'subject', type: 'string', searchable: false},
					{text: this.$t('fields.body'), value: 'body', type: 'string', searchable: false}
				],
				items: [],
				total: 0,
				lastRequest: null
			},

		}
	},
	methods: {
		reloadData(request) {
			this.lastRequest = request;
			let vm = this;
			this.$APICall('get', 'history', request, (data, success) => {
				if (success) {
					vm.historyTable.items = data.items;
					vm.historyTable.total = data.total;
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			});
		},
		reloadDataEmails(request) {
			this.lastRequest = request;
			let vm = this;
			this.$APICall('get', 'email-history', request, (data, success) => {
				if (success) {
					vm.emailTable.items = data.items;
					vm.emailTable.total = data.total;
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			});
		},
		excelExport() {
			let excelRequest = JSON.parse(JSON.stringify(this.lastRequest));
			excelRequest.pagination.rowsPerPage = 999999999;
			excelRequest.pagination.page = 1;

			let vm = this;
			this.$APICall('get', 'history', excelRequest, (data, success) => {
				if (success) {
					vm.$APICall('post', 'excel/history', data.items, (data, success) => {
						window.open(data.link);
					});
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			}, false);
		},
		excelExport() {
			let excelRequest = JSON.parse(JSON.stringify(this.lastRequest));
			excelRequest.pagination.rowsPerPage = 999999999;
			excelRequest.pagination.page = 1;

			let vm = this;
			this.$APICall('get', 'email-history', excelRequest, (data, success) => {
				if (success) {
					vm.$APICall('post', 'excel/email-history', data.items, (data, success) => {
						window.open(data.link);
					});
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			}, false);
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		this.$myStore.commit('setBreadcrumbs', [
			{text: this.$t('modules.history'), href: '/#/history', disabled: true}
		]);
	}
}
</script>

<style scoped>

</style>
